/**
 * Firebase configuration and initialization
 */

import {
    initializeApp,
} from 'firebase/app'
import {
    getAuth,
    connectAuthEmulator,
} from 'firebase/auth'
import {
    getFirestore,
    connectFirestoreEmulator,
} from 'firebase/firestore'
import {
    getStorage,
    connectStorageEmulator,
} from 'firebase/storage'
import {
    getFunctions,
    connectFunctionsEmulator,
} from 'firebase/functions'
import {
    getAnalytics,
} from 'firebase/analytics'

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyD7052OgzEkURjo4ownDYOGFzj4Y41WOwM',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'asp-servisni-centrum.firebaseapp.com',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'asp-servisni-centrum',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'asp-servisni-centrum.firebasestorage.app',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '55062064570',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:55062064570:web:f33528d4513a0f39574183',
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-1KSSDZQWYK'
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const firestore = getFirestore(app)
export const storage = getStorage(app)
export const functions = getFunctions(app, 'europe-west1')

// Connect to Firebase Emulators if enabled
const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true'

if (useEmulators) {
    console.log('🔥 Připojuji se k Firebase Emulátorům...')
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
    connectFirestoreEmulator(firestore, 'localhost', 8081)
    connectStorageEmulator(storage, 'localhost', 9199)
    connectFunctionsEmulator(functions, 'localhost', 5001)
    console.log('✓ Připojeno k Firebase Emulátorům')
} else {
    console.log('🔥 Připojuji se k produkčnímu Firebase...')
}

export const analytics = import.meta.env.PROD ? getAnalytics(app) : null

export default app
